/**
 * returns an Array.sort callback that sorts objects by value of 'key'
 * @param  {String}  key               key in the Object to use for sorting
 * @param  {Boolean} [ignoreCase=true] if true, do case-insensitive comparison
 * @return {Function}                  Array.sort callback function
 */
export default function sortByKey(key, ignoreCase = true) {
    /**
     * sort an object alphabetically by a key
     * Array.sort callback, returns -1, 0, or 1
     * @param  {Object} a object with a 'label' member
     * @param  {Object} b object with a 'label' member
     * @return {Number}   -1, 0, or 1 for sorting
     */
    return (a, b) => {
        let labelA = a[key];
        let labelB = b[key];
        if (ignoreCase) {
            labelA = labelA.toUpperCase();
            labelB = labelB.toUpperCase();
        }
        if (labelA < labelB) {
            return -1;
        }
        if (labelA > labelB) {
            return 1;
        }
        // if labels are equal
        return 0;
    };
}



// WEBPACK FOOTER //
// ./src/functions/sortByKey.js